import React from 'react';
import ChannelCard from './ChannelCard';
import { useChannelContext } from '../context/ChannelContext';
import { categoryLabels } from '../data/channels';

const ChannelGrid = ({ onPlayChannel }) => {
  const { currentChannel, getFilteredChannels, currentFilter } = useChannelContext();
  const filteredChannels = getFilteredChannels();

  if (filteredChannels.length === 0) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        color: 'var(--muted)',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>📺</div>
        <div style={{ fontSize: '16px', fontWeight: 600 }}>No channels found</div>
        <div style={{ fontSize: '13px', marginTop: '4px' }}>Try selecting a different category</div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: '12px',
      marginBottom: '20px'
    }}>
      {filteredChannels.map(channel => (
        <ChannelCard
          key={channel.id}
          channel={channel}
          isPlaying={currentChannel?.id === channel.id}
          onPlay={onPlayChannel}
        />
      ))}
    </div>
  );
};

export default ChannelGrid;